import { GET } from 'utils/requests.utils'

export const fetchData = (data) => GET('/cabinet/seller/balance', data)
